<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="form-group row">
                            <div class="col-xl-3 col-md-4 col-12 mb-2">
                                Банклар
                                <v-select
                                    v-model="client"
                                    :options="banks"
                                    label="text"
                                >
                                </v-select>
                                <!--<select class="form-control" v-model="filter.clientId">-->
                                    <!--<option value=""></option>-->
                                    <!--<option :value="option.id" v-for="option in banks" :key="option.id">-->
                                        <!--{{option.text}}-->
                                    <!--</option>-->
                                <!--</select>-->
                            </div>
                            <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-2">
                                Вилоят
                                <select class="form-control" v-model="filter.provinceId" @change="changeProvince()">
                                    <option value=""></option>
                                    <option :value="option.id" v-for="option in provinces" :key="option.id">
                                        {{option.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-2">
                                Туман
                                <select class="form-control" v-model="filter.regionId">
                                    <option value=""></option>
                                    <option :value="option.id" v-for="option in regions" :key="option.id">
                                        {{option.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-2 col-md-3 col-sm-6 col-12 mb-2">
                                {{$t("report.date.startDate")}}
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-xl-2 col-md-3 col-sm-6 col-12 mb-2">
                                {{$t("report.date.endDate")}}
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-xl-4 col-md-3 col-sm-6 col-12">
                                {{$t('main.search')}}
                                <div class="input-group">
                                    <input class="form-control search-input" type="text" :placeholder="$t('main.search')"
                                           v-model="filter.search" @keypress.enter="initList">
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" @click="initList">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th style="width:15%">{{$t("realEstate.field.name")}}</th>
                              <th style="width:15%">{{$t("report.field.district")}}</th>
                              <th>{{$t("realEstate.field.evaluatedAmount")}}</th>
                              <th style="width: 5%">{{$t("building.field.floors")}}</th>
                              <th style="width: 5%">Қавати</th>
                              <th>Бино тури</th>
                              <th style="width: 10%">{{$t("realEstate.field.areaTotal")}}</th>
                              <th style="width: 10%">{{$t("realEstate.field.areaUnderConstruction")}}</th>
                              <th style="width: 10%">{{$t("realEstate.field.areaUseful")}}</th>
                              <th>{{$t("realEstate.field.createdDate")}}</th>
                              <th>{{$t("realEstate.field.createdBy")}}</th>
                              <th>{{$t("realEstate.field.action")}}</th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                            <tr v-for="(result,index) in results.data" :key="result.id">
                              <td>{{index + 1}}</td>
                              <td>
                                <div class="font-weight-bold">{{result.name}}</div>
                              </td>
                              <td>
                                <div class="font-weight-bold">{{result.regionName}}</div>
                              </td>
                              <td>
                                {{result.totalPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                              </td>
                              <td>
                                {{result.storey}}
                              </td>
                              <td>
                                {{result.floor}}
                              </td>
                              <td>
                                {{getBuildingType(result.categoryCode)}}
                              </td>
                              <td>
                                {{result.totalArea}}
                              </td>
                              <td>
                                {{result.buildingArea}}
                              </td>
                              <td>
                                {{result.usefulArea}}
                              </td>
                              <td>{{new Date(result.createDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                              <td>
                                <div class="text-secondary">{{result.createUserName}}</div>
                              </td>
                              <td>
                                <button class="all-btn view-btn btn-sm"
                                        v-if="result.values && result.values.hasOwnProperty('analogIds')"
                                        @click="showViewAnalogIds(result)"
                                >
                                  <i class="fa fa-list"></i>
                                </button>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal v-model="showAnalogsModal" :no-close-on-esc="true" :no-close-on-backdrop="true" size="sm">
                <p v-if="result && result.values.hasOwnProperty('analogIds')"> Қийсий аналоглар: {{result.values['analogIds'].toString()}}</p>
                <p v-if="result && result.values.hasOwnProperty('landAnalogIds')"> Ер аналоглар: {{result.values['landAnalogIds'].toString()}}</p>
                <div slot="modal-footer">
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import Datepicker from 'vuejs-datepicker';
    import {formatDate} from '@/shared/utils';
    import AdvancedFilter from '@/shared/filters/advancedFilter';
    import bModal from "bootstrap-vue/es/components/modal/modal";
    import bModalDirective from "bootstrap-vue/es/directives/modal/modal";

    export default {
        name: "NewRealEstateAllList",
        components: {
          'b-modal': bModal,
          'b-pagination': bPagination,
          Datepicker
        },
        directives: {
          'b-modal': bModalDirective
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                results: null,
                buildingTypes: [],
                banks: [],
                provinces: [],
                regions: [],
                startDate: null,
                endDate: null,
                client: null,
                showAnalogsModal: false,
                result: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.getBuildingTypes();
                this.getBanks();
                this.getProvinces();
                if (this.startDate) {
                    this.filter.startDate = formatDate(this.startDate) + " 00:00:00";
                }
                if (this.endDate) {
                    this.filter.endDate = formatDate(this.endDate) + " 23:59:59";
                }

                this.filter.clientId = null;
                if (this.client) {
                    this.filter.clientId = this.client.id;
                }

                this.$http.post('new-comparative/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeStatus() {
                this.filter.page.page = 1;
                this.initList()
            },
            getBuildingTypes() {
                this.buildingTypes = [];
                this.filterBuildingType.onlyParentLookUp = true
                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        this.buildingTypes = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getBuildingType(code) {
                for (let i = 0; i < this.buildingTypes.length; i++) {
                    if (this.buildingTypes[i].code === code) {
                        return this.buildingTypes[i].name;
                    }
                }
            },
            getBanks() {
                this.banks = [];
                this.$http.get('banks')
                    .then(res => {
                        this.banks = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getProvinces() {
                this.provinces = [];
                this.$http.get('province/init')
                    .then(res => {
                        this.provinces = res.data.provinces;
                    }, err => {
                        console.log(err);
                    });
            },
            changeProvince() {
                let regions = [];
                if (this.filter.provinceId && this.filter.provinceId > 0 && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.provinceId && province.regions && province.regions.length > 0) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
            },
            showViewAnalogIds(result) {
              this.showAnalogsModal = true
              this.result = result
            }
        },
        watch: {
            $route(to, from) {
                console.log(to);
                console.log(from);
                this.initList();
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>